@if (formGroup) {
  <form [formGroup]="formGroup" (ngSubmit)="save()">
    <dialog class="bm-modal" open (document:keydown.escape)="closeModal.emit()">
      <div class="bm-modal-box max-h-[80vh] overflow-y-auto w-full">
        <ng-container *ngTemplateOutlet="tplFormContent" />
        <div class="bm-modal-action">
          <button class="bm-btn bm-btn-secondary" type="button" (click)="closeModal.emit()">Abbrechen</button>
          <button class="bm-btn bm-btn-primary" [disabled]="!formGroup.valid">Speichern</button>
        </div>
      </div>
    </dialog>
  </form>
}

<ng-template #tplFormContent>
  <h4 class="text-lg font-bold mb-2">Aufgabe erstellen</h4>
  <fieldset class="bm-fieldset px-0">
    <label class="bm-fieldset-label">Name*</label>
    <input class="bm-input" formControlName="name" />

    <label class="bm-fieldset-label">Verantwortliche</label>
    <select class="bm-select" formControlName="user_ids" multiple>
      <option>Test</option>
    </select>
    <p>Wählen Sie einen oder mehrere Techniker aus...</p>

    <label class="bm-fieldset-label">
      <input class="bm-checkbox" type="checkbox" formControlName="use_deadline" />Deadline verwenden
    </label>

    @if (formGroup.controls["use_deadline"].value) {
      <label class="bm-fieldset-label">Deadline</label>
      <label class="bm-input">
        <input type="number" min="0" matInput formControlName="deadline_days" />
        <span class="bm-label w-16">Tage</span>
      </label>
      <label class="bm-input">
        <input type="number" min="0" matInput formControlName="deadline_hours" />
        <span class="bm-label w-16">h</span>
      </label>
      <label class="bm-input">
        <input type="number" min="0" matInput formControlName="deadline_minutes" />
        <span class="bm-label w-16">min</span>
      </label>
      <label class="bm-fieldset-label">An</label>
      <select class="bm-select" formControlName="deadline_user_ids" multiple>
        <option>Test</option>
      </select>
      <p>Wählen Sie einen oder mehrere Nutzer aus...</p>

      <label class="bm-fieldset-label">Per</label>
      <div class="flex flex-col">
        <label class="bm-label"> <input type="checkbox" class="bm-checkbox" formControlName="mail" />Mail </label>
        <label class="bm-label"> <input type="checkbox" class="bm-checkbox" formControlName="sms" />Sms </label>
      </div>
    }
  </fieldset>
</ng-template>
